import { render, staticRenderFns } from "./CreateTicket.vue?vue&type=template&id=6949ed8c&scoped=true&"
import script from "./CreateTicket.vue?vue&type=script&lang=js&"
export * from "./CreateTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6949ed8c",
  null
  
)

export default component.exports